<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main">
      <div class="title-area" id="modal-moving">
        <h2>面間距離を指定して移動</h2>
      </div>
      <div class="input-area">
        <ul>
          <li>
            <span class="label">面間距離(mm)：</span>
            <input type="number" v-model.number="faceDistance" placeholder="面間距離">
            <div class="error_message">{{ errorMessage.text }}</div>
            <div class="error_message">{{ fieldErrorMessages.faceDistance }}</div>
          </li>
        </ul>
      </div>
      <div class="button-area">
        <button type="button" class="main_btn" @click="onOk">移動</button>
        <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, KEY_CODE} from '../../../constants/App'
import {EDIT_TYPE, VIEW_TYPE, AXIS_TYPE, OBJECT_TYPE} from '../../../constants/Type'
import * as Api from '../../../utils/Api'
import * as SpaceUtil from '../../../utils/Space'
import * as FaceUtil from '../../../utils/Face'

export default {
  name: 'FaceDistanceMoveModal',
  props: {
    /** 選択面[{space: SpaceModel, faceType: FACE_TYPE},...] */
    selectedFaces: Array,
    isPlanning: Boolean,
    globalSpaces: Array
  },
  computed: {
  },
  data () {
    return {
      modalShown: false,
      faceDistance: null,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      fieldErrorMessages: {
        faceDistance: ''
      }
    }
  },
  watch: {
    modalShown: function () {
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.modalShown = true
    },
    /** 設定ボタン押下時 */
    onOk: function (event) {
      if (!this.modalShown) return
      event.preventDefault()
      this.clearMessages()
      this.setFaceDistance()
    },
    /** キャンセルボタン押下時 */
    onCancel: function (event) {
      event.preventDefault()
      this.modalShown = false
      this.clearMessages()
      this.clearForm()
      this.$emit('changeFaceDistanceMode', false, true)
    },
    /** enter/escキー押下時 */
    onKeydown: function (event) {
      if (!event.ctrlKey && !event.shiftKey && !event.altKey && event.keyCode === KEY_CODE.ENTER) {
        this.onOk(event)
      } else if (event.keyCode === KEY_CODE.ESC) {
        this.onCancel(event)
      }
    },
    /** 面間距離設定 */
    setFaceDistance: function () {
      if (this.faceDistance === null) {
        this.fieldErrorMessages.faceDistance = '面間距離は必須です。'
        return
      }
      if (!this.selectedFaces || this.selectedFaces.length !== 2) return

      let baseSpace = this.selectedFaces[0].space
      let baseFace = this.selectedFaces[0].faceType
      let targetSpace = this.selectedFaces[1].space
      let targetFace = this.selectedFaces[1].faceType

      // 平行面の判定
      if (FaceUtil.isFaceOfAxis(targetFace) !== FaceUtil.isFaceOfAxis(baseFace)) return

      // 移動量算出
      let targetFacePos = FaceUtil.getFacePosition(targetSpace, targetFace)
      let baseFacePos = FaceUtil.getFacePosition(baseSpace, baseFace)
      let direction = 1
      if (targetFacePos < baseFacePos || (targetFacePos === baseFacePos && FaceUtil.isBaseFace(baseFace))) {
        direction = -1
      }
      let moveAmount = baseFacePos + (direction * this.faceDistance) - targetFacePos

      // プランニング時に親コンバインがある場合は移動対象は親コンバイン
      if (this.isPlanning) {
        let parentCombine = SpaceUtil.getParentByCond(
          targetSpace,
          this.globalSpaces,
          space => space.spaceObjectType === OBJECT_TYPE.COMBINE.code
        )
        if (Object.keys(parentCombine).length) targetSpace = parentCombine
      }

      // 送信データ
      let payload = {
        spaceJoincd: targetSpace.spaceJoincd,
        spaceIds: [targetSpace.id],
        editType: EDIT_TYPE.MOVE,
        viewType: VIEW_TYPE.FRONT.code,
        dx: FaceUtil.isFaceOfAxis(targetFace, AXIS_TYPE.X) ? moveAmount : 0,
        dy: FaceUtil.isFaceOfAxis(targetFace, AXIS_TYPE.Y) ? moveAmount : 0,
        dz: FaceUtil.isFaceOfAxis(targetFace, AXIS_TYPE.Z) ? moveAmount : 0
      }

      // 送信
      axios.post(API_URL.PLANNING + '/move', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.errorMessage.text = response.data.errorMessage
          } else {
            this.modalShown = false
            this.clearMessages()
            this.clearForm()
            this.$emit('setResponseData', response)
            this.$emit('changeFaceDistanceMode', false, true)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
        })
    },
    clearForm: function () {
      this.faceDistance = null
    },
    clearMessages: function () {
      this.errorMessage = { text: '' }
      this.fieldErrorMessages = {
        faceDistance: ''
      }
    }
  },
  created: function () {
  }
}
</script>

<style scoped>
.label {
  display: inline-block;;
  text-align: right;
  min-width: 110px;
}
.error_message {
  margin-top: 10px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/FaceDistanceMoveModal.vue